<div class="container">
  <div class="row body-centered">
    <div class="card-body text-center">

      <h5 class="card-title">WhatsApp Verification</h5>

      <div class="mt-4">

        <p class="small text-muted">
          Code sent to [<strong>{{ whatsapp }}</strong>] via WhatsApp
        </p>

        <label class="form-label d-block text-center">Enter code</label>

        <div class="d-flex justify-content-center gap-2 my-3" #otpContainer>
          <input type="text" maxlength="1" class="form-control text-center" />
          <input type="text" maxlength="1" class="form-control text-center" />
          <input type="text" maxlength="1" class="form-control text-center" />
          <input type="text" maxlength="1" class="form-control text-center" />
          <input type="text" maxlength="1" class="form-control text-center" />
          <input type="text" maxlength="1" class="form-control text-center" />
        </div>

        <p class="text-muted">Code expires in <strong>{{ timer }}s</strong></p>

        <div class="d-flex justify-content-center gap-2">
          <button class="btn btn-outline-secondary" [disabled]="timer > 0" (click)="resendOtp()">Resend</button>
          <button class="btn btn-success" (click)="verifyOtp()">Verify</button>
        </div>

      </div>
    </div>
  </div>
</div>